<template>
  <!-- 我的点赞 -->
  <div class="box">
    <div class="sec-flex">
      <div
        :class="['flex-txt', active === item.code ? 'cur' : '']"
        v-for="item in likeList"
        :key="item && item.code"
        @click="handleCheck(item)"
      >
        <span>{{ item && item.label }}</span>
        <img
          v-show="item.code === active"
          src="@/assets/images/zone/img2.png"
          class="icon1"
          alt=""
        />
      </div>
    </div>
    <div class="flex-nav">
      <template v-if="`${active}` === '0'">
        <div class="nav-btn" v-for="(item, index) in myLikeTabs" :key="index" @click="handleClickNav(item.kind)">
          <img :src="item && item.iconChecked" v-if="navKind === item.kind" class="icon-nav-btn" alt="">
          <img :src="item && item.icon" v-else class="icon-nav-btn" alt="">
        </div>
      </template>
    </div>
    <div class="list">
      <van-list
        v-model="postState.loading"
        :finished="postState.finished"
        :finished-text="postState.finishText"
        @load="handleGetPostList"
      >
        <div v-if="postListArr.length > 0">
          <div
            class="block1-item"
            v-for="(item, index) in postListArr"
            :key="index"
            @click="handleClickItems(item)"
          >
            <div class="item-top">
              <img
                v-if="active != 1"
                :src="userInfo.headPicUrl"
                class="top-cover"
                alt=""
              />
              <img v-else :src="item.targetHeadPic" class="top-cover" alt="" />
              <div class="top-con">
                <div class="txt1" v-if="active != 1">
                  我点赞了{{ item.targetUserName }}
                </div>
                <div class="txt1" v-else>{{ item.userName }}点赞了我</div>
                <div class="txt2">
                  <span class="txt2-time">{{
                    $moment(item.createTime * 1).format("YYYY-MM-DD HH:mm:ss")
                  }}</span>
                </div>
              </div>
            </div>
            <div class="con-div">
              <div class="content_info">
                <div class="info">
                  <div class="name">
                    {{ item.likeTitle }}
                  </div>
                </div>
                <div class="img_box">
                  <img class="img" :src="item.cover" alt="" />
                  <div class="type">{{ CLTypeObj[item.kind] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-block" v-else-if="isNone">
          <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
          <div class="empty-txt">暂无内容</div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { likeList, CLTypeObj, myLikeTabs } from './data'
import { myLike, likeMe, myLikeCase, likeMeCase } from '../../api/like_comment'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data() {
    return {
      likeList,
      myLikeTabs,
      active: 0,
      CLTypeObj,
      postListArr: [],
      postState: {
        pageNum: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      isNone: false,
      navKind: 6
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    handleClickNav(kind) {
      this.navKind = kind
      this.postState.pageNum = 1
      this.postState.finished = true
      this.postListArr = []
      this.handleGetPostList()
    },
    async handleCheck(item) {
      this.navIndex = `${item.code}` === '0' ? 0 : 1
      this.postState.pageNum = 1
      this.postState.finished = true
      this.postListArr = []
      this.active = item.code
      this.handleGetPostList()
    },
    handleClickItems() {

    },
    handleGetPostList() {
      let params = {
        id: this.userInfo.id,
        pageNum: this.postState.pageNum,
        pageSize: this.postState.pageSize,
        type: this.navKind === 13 ? 12 : undefined
      }
      let method = this.active === 1 ? likeMe : myLike
      switch (`${this.navKind}`) {
        case 4:
          method = this.active === 1 ? likeMeCase : myLikeCase
          delete params.id
          params.openId = this.userInfo.iepOpenId
          break
        default:
          params.kind = this.navKind
          break
      }
      method(params)
        .then(res => {
          this.$toast.clear()
          if (typeof res === 'string') {
            res = JSON.parse(res)
            res.code = 0
            res.data = {
              list: res.results.map(item => {
                item.createTime = new Date(item.time_create).getTime()
                item.likeTitle = item.title
                item.cover = item.icon
                return item
              })
            }
          }
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.postState.loading = false
              this.postState.finished = true
              return false
            }
            this.postState.finished = false
            this.postState.loading = false
            if (res.data.list.length < this.postState.pageSize) {
              this.postState.finished = true
              this.postState.finishText = '没有更多了'
            }
            if (res.code === 0 && res.data.list) {
              this.postListArr = this.postListArr.concat(res.data.list)
            }
            this.postState.pageNum++
            if (this.postListArr.length === 0) {
              this.isNone = true
              this.postState.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.box {
  background: #F9F8F7;
  padding-top: 80px;
}
.bg1 {
  width: 375px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  img {
    width: 375px;
  }
}
.sec-flex {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  height: 42px;
  align-items: center;
  border-radius: 12px 12px 0 0;
  background: #fff;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 9;

  .flex-txt {
    flex: 1;
    position: relative;
    height: 42px;
    line-height: 42px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 14px;
    color: #656e7f;
    margin-right: 18px;
    text-align: center;

    &:nth-last-child(1) {
      margin-right: 0;
    }

    &.cur {
      font-weight: 600;
      color: #EB1700;
    }

    .icon1 {
      position: absolute;
      width: 23px;
      bottom: 4px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.flex-nav {
  display: flex;
  top: 42px;
  padding: 0 16px;
  box-sizing: border-box;
  z-index: 9;
  width: 100%;
  position: fixed;
  height: 40px;
  align-items: center;
  overflow-x: auto;
  .icon-nav-btn {
    height: 22px;
    display: block;
    margin-right: 2px;
  }
}
.list {
  padding: 16px;
  box-sizing: border-box;
  position: relative;
  min-height: calc(100vh - 90px);
}
.color {
  color: #EB1700 !important;
}

.block1-item {
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 12px;
  border: 1px solid #fff;
  box-sizing: border-box;

  .item-top {
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    background: linear-gradient(90.00deg, rgb(241, 239, 237),rgb(255, 255, 255) 100%);
    border-radius: 12px 12px 0 0;

    .top-cover {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 4px;
    }

    .top-con {
      display: flex;
      flex-direction: column;

      .txt1 {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #b1b1b1;
      }

      .txt2 {
        display: flex;
        align-items: center;

        .txt2-tag {
          width: 40px;
          height: 14px;
          border-radius: 2px;
          border: 1px solid #EB1700;
          margin-right: 4px;
          color: #EB1700;
          font-size: 10px;
          text-align: center;
        }

        .txt2-time {
          font-size: 12px;
          font-weight: 500;
          color: #7a8494;
        }
      }
    }
  }

  .con-div {
    padding: 10px;
    padding-bottom: 0;
    box-sizing: border-box;

    .item-title {
      font-size: 14px;
      color: #202020;
      font-weight: 600;
      line-height: 20px;
      margin-bottom: 5px;
    }

    .item-cons {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #202020;
      line-height: 20px;
      margin-bottom: 4px;
    }
    .content_info {
      min-height: 80px;
      padding: 6px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        padding: 10px 0;
        box-sizing: border-box;
        max-width: 200px;
        .name {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #000000;
          margin-bottom: 6px;
        }
      }

      .img_box {
        width: 109px;
        height: 60px;
        position: relative;
        .img {
          width: 109px;
          height: 60px;
        }
        .type {
          padding: 0 4px;
          box-sizing: border-box;
          height: 16px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 0px 8px 0px 0px;
          position: absolute;
          bottom: 0;
          left: 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 12px;
          color: #000000;
          text-align: center;
          line-height: 16px;
        }
      }
    }
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
    margin: 0 auto;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/myLike.vue